import { render } from "./ResetPasswordError.vue?vue&type=template&id=0928170e&scoped=true"
import script from "./ResetPasswordError.vue?vue&type=script&lang=js"
export * from "./ResetPasswordError.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=0928170e&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0928170e"]])

export default __exports__